export default __webpack_public_path__ + "static/assets/a4c78e34e75a3b3ce76d65be091e26db.svg";